import { gql } from '@apollo/client';

const Fragments = {
  scoringCategory: gql`
    fragment scoringCategory on ScoringCategory {
      scoringId
      orderNo
      code
      name
    }
  `
};

export default Fragments;
